let channel: BroadcastChannel | null = null;

const otherTabProhibitedHtmlBody = `
                    <style>
    * {
      font-family: "Open Sans", sans-serif;
      margin: 0;
      padding: 0;
    }

    html, body {
      -webkit-font-smoothing: antialiased;
      font-family: "Open Sans", sans-serif;
      background: #0019A5;
      color: white;
    }

    h1 {
      font-style: normal;
      font-size: 32px;
      font-weight: 600;
      line-height: 42px;
    }

    a, a:visited {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      text-decoration: underline;
      color: white;
    }

    a:hover {
      text-decoration: none;
      color: white;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }

    .error-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      opacity: 0.5;
    }

    .mt {
      margin-top: 32px;
    }

    .app-bar {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      padding-top: 16px;
      padding-bottom: 16px;
      padding-left: 32px;
    }

    .logo {
      position: relative;
      height: 100%;
    }

    .logo svg {
      max-height: 32px;
    }

    .container {
      position: relative;
      width: 960px;
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
    }

    .container-text {
      display: flex;
      flex-direction: row;
      min-height: 500px;
      align-items: center;
    }

    .flex {
      display: flex;
      gap: 32px;
    }

    .flex-row {
      flex-direction: row;
    }

    .flex-grow {
      flex-grow: 1;
    }

    .p-32 {
      padding: 32px;
    }

    .buttons{
      display: flex;
      flex-direction: row;
      gap: 12px;
      margin-top: 32px;
    }

    .btn, .btn:visited {
      background: white;
      color: #0019A5;
      padding: 8px 16px 8px 16px;
      text-decoration: none;
      border-radius: 8px;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
    }

    .btn:hover {
      opacity: 0.9;
    }

    @media (max-width: 480px) {
      h1 {
        font-style: normal;
        font-size: 24px;
        font-weight: 600;
        line-height: 28px;
      }

      .app-bar {
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 16px;
      }

      .logo svg {
        max-height: 24px;
      }

      .container {
        position: relative;
        width: 100%;
      }

      .container-text {
        min-height: 0;
      }

      .flex-row {
        flex-direction: column-reverse;
      }

      .p-32 {
        padding: 16px;
      }

      .mt {
        margin-top: 24px;
      }

      .btn{
        width: 100%;
      }
    }
  </style>
            <div class="page">
              <div class="app-bar">
                <div class="logo">
                  <svg viewBox="0 0 136 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M56.6408 4.91851H61.7515V0.0080532H56.6408V4.91851ZM96.235 14.8163C96.235 6.60653 100.811 1.04389 109.279 1.04389C117.631 1.04389 122.323 6.72164 122.323 14.8163C122.323 22.9109 117.707 28.742 109.279 28.742C100.735 28.742 96.235 23.0259 96.235 14.8163ZM101.804 14.8162C101.804 19.65 103.824 24.5221 109.279 24.5221C114.732 24.5221 116.754 19.65 116.754 14.8162C116.754 10.0976 114.58 5.26378 109.279 5.26378C103.977 5.26378 101.804 10.0976 101.804 14.8162ZM129.685 30.9977L130.829 30.0081C132.339 28.6962 135.703 25.5431 135.703 22.4129C135.703 19.2138 133.14 17.6947 129.571 17.6947C128.632 17.6947 127.122 17.8099 124.834 18.6384L124.994 21.9757C125.978 21.4003 127.809 20.8709 129.181 20.8709C130.463 20.8709 131.447 21.4694 131.447 22.8963C131.447 24.9017 128.222 27.6982 125.163 30.3508L125.163 30.3509L125.163 30.351L125.163 30.3511C124.922 30.56 124.682 30.7681 124.445 30.9748V34.0358H136V30.9977H129.685ZM73.8867 8.06427C67.7845 8.06427 64.7715 12.7829 64.7715 18.4991C64.7715 24.9824 68.5474 28.742 75.0312 28.742C77.777 28.742 79.9129 28.2049 81.7815 27.1692V22.9876C79.8748 24.0617 77.7389 24.9824 75.2596 24.9824C72.0942 24.9824 69.8822 23.1794 69.653 19.9952H83.2313C83.2313 13.0898 81.1716 8.06427 73.8867 8.06427ZM69.6531 16.4658C69.8822 13.8188 71.3313 11.8239 74.1921 11.8239C77.0528 11.8239 78.1966 13.9722 78.3489 16.4658H69.6531ZM53.5132 32.8086C56.2593 32.6551 56.6407 32.1181 56.6407 29.049V8.52472H61.7514V29.7395C61.7514 32.54 60.9505 36.7984 55.8397 36.7984C55.0006 36.7984 53.9709 36.6833 53.3225 36.4915L53.5132 32.8086ZM33.2512 18.5374C33.2512 12.0157 37.7135 8.06427 43.5108 8.06427C49.3462 8.06427 53.8085 12.0157 53.8085 18.5374C53.8085 24.2152 50.0326 28.742 43.5108 28.742C37.027 28.742 33.2512 24.2152 33.2512 18.5374ZM38.5907 17.9236C38.5907 21.1844 39.6205 24.7522 43.5108 24.7522C47.4391 24.7522 48.4688 21.2228 48.4688 17.9236C48.4688 14.8929 46.867 12.054 43.5108 12.054C40.1926 12.054 38.5907 14.9696 38.5907 17.9236ZM14.8745 21.7983H14.9508L21.282 1.50423H29.8252V28.2817H24.7145V6.18453H24.6382L17.468 28.2817H12.3573L5.18697 6.18453L5.11074 6.26127V28.2817H0V1.50423H8.54325L14.8745 21.7983Z"
                          fill="white"/>
                  </svg>
                </div>
              </div>
              <div class="container">
                <div class="flex flex-row">
                  <div class="flex-grow p-32 container-text">
                    <div>
                      <h1>Moje O2 podporuje pouze jeden otevřený tab</h1>
                      <p class="mt">Pokud jste otevřeli Moje O2 ve dvou záložkách, je nutné jednu z nich zavřít.</p>
                      <div class="buttons">
                        <a class="btn" href="/">Přejít na dashboard Moje O2</a>
                      </div>
                      <p class="error-text mt">Chyba 403: Forbidden</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        `;

/**
 * Running script denies opening another app with same applicationGroupName by running named BroadcastChannel and posting message.
 * Changing application name creates another channel which is then shared between app with same applicationGroupName.
 *
 * @param applicationGroupName - application channel name for sharing same BroadcastChannel
 * @param denyInOtherTab - true by default. Setting to false will allow running given
 */
export const shouldDenyInOtherTabs = (applicationGroupName = 'o2-moje-o2', denyInOtherTab = true) => {
  if (applicationGroupName !== channel?.name) {
    channel?.close();
    channel = new BroadcastChannel(applicationGroupName);
    channel.postMessage('another-tab');
    channel.addEventListener('message', (msg) => {
      const isInternal = Boolean(
        // We are unsure about data given by Adobe Analytics and cannot be sure whether given attribute would survive some of the Adobe Analytic structure update. That's why any.
        window.adobeDataLayer?.find((adobeEvent: any) => adobeEvent?.userInternal?.userType === 'internal')
      );

      if (msg.data === 'another-tab' && isInternal && denyInOtherTab) {
        const overlayHtml = document.createElement('body');

        overlayHtml.innerHTML = otherTabProhibitedHtmlBody;
        document.body = overlayHtml;
        channel?.close();
      }
    });
  }
};
